import React from 'react';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import { Dialog, Table } from 'components';

const columns = [{ label: 'Propriedade' }, { label: 'Valor' }];

export const DialogTestDetails = ({ open, onClose, test }) => {
  const details = test?.details || {};

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md'>
      <Dialog.Title onClose={onClose}>Detalhes — {test?.name}</Dialog.Title>
      <Dialog.Content>
        <Table headers={columns} disableNumeration maxHeight>
          {Object.entries(details).map(([key, value]) => (
            <TableRow key={key}>
              <TableCell>{key}</TableCell>
              <TableCell>{value === null || value === undefined ? '-' : String(value)}</TableCell>
            </TableRow>
          ))}
        </Table>
      </Dialog.Content>
    </Dialog>
  );
};
